function LoggedOff({ headingText, bodyText }: { headingText: string; bodyText?: string }) {
  return (
    <div className="text-center">
      <h1 className={`${!bodyText ? 'mb-4' : ''}`}>{headingText}</h1>
      {bodyText && <div className="mb-3">{bodyText}</div>}
      <a href="/konto/logga-in">Logga in</a>
    </div>
  );
}

export default LoggedOff;
